var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHmIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_300_5015)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.6244 0C15.2795 0 15 0.279545 15 0.624351V14.3597C15 14.7045 15.2795 14.984 15.6244 14.984H29.3597C29.7045 14.984 29.984 14.7045 29.984 14.3597C29.975 6.43274 23.5512 0.00895526 15.6244 0Z",
    fill: "#FFC107"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.361 26.4623L13.7514 15.3942V1.8724C13.7514 1.52759 13.4719 1.24805 13.1271 1.24805C5.89732 1.24805 0.0161133 7.68992 0.0161133 15.6077C0.0250685 23.5346 6.44886 29.9584 14.3757 29.9673C17.2539 30.191 20.0998 29.2386 22.2636 27.3276C22.525 27.1132 22.5682 26.7296 22.361 26.4623Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3598 16.2324H16.8732C16.5284 16.2325 16.2489 16.5121 16.249 16.8569C16.249 16.9995 16.2979 17.1378 16.3875 17.2488L24.5038 27.2968C24.6127 27.4319 24.7729 27.5155 24.9459 27.5278H24.9896C25.1476 27.5279 25.2997 27.4681 25.4154 27.3605C28.3238 24.6406 29.9775 20.8388 29.9843 16.8567C29.9842 16.512 29.7047 16.2324 29.3598 16.2324Z",
    fill: "#4CAF50"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_300_5015"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHmIcon4);
export default __webpack_public_path__ + "static/media/hm-icon4.0e1652fa2b6576852f0db7f5c086db4a.svg";
export { ForwardRef as ReactComponent };